import { getUser } from 'src/utils/Common';
import axios from '../../utils/axios';

export const GetWarehouseAddress = () => {
  const user = getUser();
  return axios.get(`/GetWarehouseAddress/${user.ServiceShopId}/${user.OrganizationUserId}`);
};

export const SetWarehouseInventory = (materialCode, warehouseId) => {
  const user = getUser();
  return axios.get(`/SetWarehouseInventory/${user.ServiceShopId}/${user.OrganizationUserId}/${materialCode}/${warehouseId}`);
};

export const UpdateWarehouseInventory = (id, count) => {
  const user = getUser();
  return axios.get(`/UpdateWarehouseInventory/${id}/${user.OrganizationUserId}/${user.ServiceShopId}/${count}`);
};
